import styled from 'styled-components';
import { screenSmMin } from '@spotify-internal/encore-foundation';
import { sidebarBaseWidth, sidebarSlimBaseWidth, zIndexFixed } from "../../styles";

var defaultSidebarWidth = function defaultSidebarWidth(props) {
  return props.navigationSlim ? sidebarSlimBaseWidth : sidebarBaseWidth;
};

export default styled.aside.withConfig({
  displayName: "Aside",
  componentId: "sc-1j1p3pv-0"
})(["@media (min-width:", "){height:100%;left:0;position:fixed;top:0;width:", ";z-index:", ";}"], screenSmMin, function (props) {
  return props.sidebarWidth || defaultSidebarWidth;
}, zIndexFixed);